import type { PointerEvent as ReactPointerEvent, ReactNode } from "react";

const LAYER_INSPECTOR_POPUP_CONTAINER_ID = "layer-inspector-popup-root";

function getLayerInspectorPopupContainer(
  triggerNode: HTMLElement
): HTMLElement {
  const ownerDocument = triggerNode.ownerDocument;
  let container = ownerDocument.getElementById(
    LAYER_INSPECTOR_POPUP_CONTAINER_ID
  );

  if (!container) {
    container = ownerDocument.createElement("div");
    container.id = LAYER_INSPECTOR_POPUP_CONTAINER_ID;
    container.setAttribute("data-layer-inspector-keep-selection", "");
    ownerDocument.body.appendChild(container);
  }

  return container;
}

function renderLayerInspectorPopup(menu: ReactNode): JSX.Element {
  return (
    <div
      data-layer-inspector-keep-selection
      onPointerDown={(event: ReactPointerEvent<HTMLDivElement>) =>
        event.stopPropagation()
      }
    >
      {menu}
    </div>
  );
}

export const layerInspectorPopupProps = {
  getPopupContainer: getLayerInspectorPopupContainer,
  popupRender: renderLayerInspectorPopup,
};
